var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FlechaSubir"},[_c('a',{staticClass:"scroll-to-top btnScrollTop shadow-lg",attrs:{"id":"BackTop"}},[_c('center',[_c('ion-icon',{staticClass:"mt-2",staticStyle:{"font-size":"15pt"},attrs:{"name":"arrow-up"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }